const checkDomain = (domains) => {
    return domains.some(domain => window.location?.hostname?.includes(domain));
};

export const isLowside = () => {
    return checkDomain(["localhost", "saberdevusa.xyz", "saberastro.com", "spacecockpit.space"]);
}

export const INDIVIDUAL_HEADER_HEIGHT = 16;
export const OPT_HEADER_HEIGHT = (exercise, includeExerciseData) => {
    let height = 0;
    if(exercise) height += INDIVIDUAL_HEADER_HEIGHT;
    if(includeExerciseData) height += INDIVIDUAL_HEADER_HEIGHT;
    return height;
}

export const UNCLASS_HEADER_HEIGHT = isLowside() ? 16 : 0;
export const HEADERS_HEIGHT = (exercise, includeExerciseData) => UNCLASS_HEADER_HEIGHT + OPT_HEADER_HEIGHT(exercise, includeExerciseData);